import { useMemo } from 'react'

import { ChainId } from '@src/configs/chainInfo'
import officialCCTPABI from '@src/contract/abi/cctpOfficialContract.abi.json'
import orderBookV2_1ABI from '@src/contract/abi/orderBookV2.1Contract.abi.json'
import orderBookV2ABI from '@src/contract/abi/orderBookV2Contract.abi.json'
import { ExchangeType, LiquiditySource } from '@src/enums'
import { IExchangeData } from '@src/types/exchange'
import { isFeatureEnabled } from '@src/utils/environment'
import { useConfigStore } from '@src/zustand_stores'

// Even if the liquidity source is unavailable this hook will default to returning
// values for our custom smart contract. This is fine because stopping the trade
// flow will be handled elsewhere.
export const useSwapContract = (sellData: IExchangeData, liquiditySource: LiquiditySource) => {
    const swapContracts = useConfigStore(config => config.swapContracts)

    const contractABI = useMemo(() => {
        if (liquiditySource === LiquiditySource.cctpDirect) {
            return officialCCTPABI
        }
        return orderBookV2_1ABI
    }, [liquiditySource])

    const address = useMemo(() => {
        let exchangeType: ExchangeType

        if (liquiditySource === LiquiditySource.cctpDirect) {
            exchangeType = ExchangeType.cctp
        } else if (sellData.chainId === ChainId.Tron || sellData.chainId === ChainId.Solana) {
            exchangeType = ExchangeType.order_book
        } else {
            exchangeType = ExchangeType.order_book_v2
        }

        const contractsObj = swapContracts[exchangeType]

        return contractsObj?.[sellData.chainId]
    }, [sellData, liquiditySource])

    return { abi: contractABI, address }
}
